import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { api } from "@/lib/api";

const Box = ({ icon: I, color, title, text, testid }) => (
  <div className="mx-auto max-w-md px-6 py-24 text-center" data-testid={testid}>
    <I className={`mx-auto h-12 w-12 ${color}`} />
    <h1 className="mt-4 font-display text-3xl font-semibold">{title}</h1>
    <p className="mt-3 text-sm text-slate-600">{text}</p>
    <Link to="/espace-client/factures" className="mt-8 inline-block rounded-full bg-[#0F2840] px-6 py-3 text-sm font-bold text-white" data-testid="payment-back-btn">Retour à mes factures</Link>
  </div>
);

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [state, setState] = useState("pending");
  const [kind, setKind] = useState("facture");
  useEffect(() => {
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        setKind(data.kind);
        if (data.payment_status === "paid") return setState("paid");
        if (data.status === "expired") return setState("failed");
      } catch {
        return setState("failed");
      }
      tries += 1;
      if (tries < 15) timer = setTimeout(poll, 2000);
      else setState("timeout");
    };
    if (sid) poll();
    else setState("failed");
    return () => clearTimeout(timer);
  }, [sid]);
  if (state === "paid") return <Box icon={CheckCircle2} color="text-emerald-600" title="Paiement confirmé" text={kind === "abonnement" ? "Merci ! Le paiement mensuel par carte de votre abonnement est activé. Le premier prélèvement a lieu à la prochaine échéance." : "Merci ! Votre paiement a bien été enregistré. Votre facture est marquée comme réglée."} testid="payment-success" />;
  if (state === "failed") return <Box icon={XCircle} color="text-[#D82C2C]" title="Paiement non abouti" text="Le paiement n'a pas pu être confirmé. Vérifiez son état dans vos factures avant de réessayer." testid="payment-failed" />;
  if (state === "timeout") return <Box icon={Loader2} color="text-slate-400" title="Vérification en cours" text="La confirmation prend plus de temps que prévu. Rechargez cette page dans quelques instants." testid="payment-timeout" />;
  return <Box icon={Loader2} color="animate-spin text-slate-400" title="Vérification du paiement…" text="Merci de patienter quelques secondes." testid="payment-pending" />;
}

export function PaymentCancel() {
  return <Box icon={XCircle} color="text-slate-400" title="Paiement annulé" text="Vous avez annulé le paiement. Aucun montant n'a été débité." testid="payment-cancel" />;
}
